import { useState, useEffect, React } from "react";
import useHttp from "../../../hooks/useHttp";
import APIService from "../../../services/apiAxiosService";
import displayToastMessage from "../../Common/Alert/displayToastMessage";
import {Select} from "@appkit4/react-components/select";
import PropTypes from "prop-types";
import "../../../../src/styles/userManagement.css";

const EditAssessorModal = (props) => {
    let { assessorID, setAssessorID, handleCancel, setVisible, vendorAssessmentRequestID, fetchAssessmentListAdmin, setVendorAssessmentRequestID, setSearch } = props;
    const [assessorList, setAssessorList] = useState([]);
    const { sendRequest: getAllAssessorsList } = useHttp();
    const { sendRequest: editAssessorAdmin } = useHttp();

    useEffect(() => {
        fetchAssessorList();
    }, []);

    const fetchAssessorList = () => {
        getAllAssessorsList(APIService.getAllAssessorsList(), responseHandler, errorHandler);
    };

    const responseHandler = (result) => {
        if (result.CODE) {
          setAssessorList(result.MSG);
        }
    };

    const errorHandler = () => {
        displayToastMessage("Something went wrong, Please try again!", "error");
    };

    const handleSelect = (e) => {
        setAssessorID(e);
    }

    const handleSubmit = () => {
        let data = {
            assessorID: assessorID,
            vendorRequestID: vendorAssessmentRequestID
        }
        editAssessorAdmin(APIService.editAssessorAdmin(data), responseHandlerEdit, errorHandler);
    }

    const responseHandlerEdit = (result) => {
        if (result.MSG === "Assessor Changed") {
            setVisible(false);
            setSearch("");
            displayToastMessage("Assessor has been updated successfully", "success");
            fetchAssessmentListAdmin();
            setAssessorID(null);
            setVendorAssessmentRequestID(null);
        }
        else {
            displayToastMessage("Something went wrong, Please try again!", "error");
            setVisible(false);
            setSearch("");
            setAssessorID(null);
            setVendorAssessmentRequestID(null);
        }
    }

    return (
        <div className="row">
            <div className="col">
                <div className="cv-input-field-container">
                    <label className="cv-input-label">
                        Assessor  <span className="asterisk-required">*</span>
                    </label>
                    <Select
                    showSearchOnToggle={true}
                    dropdownRenderMode="portal"
                    searchable={true}
                    value={assessorID}
                    className="cv-input-field"
                    name="assessment"
                    data={assessorList}
                    labelKey="user_name"
                    valueKey="user_id"
                    placeholder="Select Assessor"
                    onSelect={handleSelect}
                    >
                    </Select>
                </div>
            </div>
            <div className="options-container">
                <button
                        type="button"
                        className="cancel-button mt-4"
                        onClick={handleCancel}
                    >
                        Cancel
                    </button>
                    <button
                        type="submit"
                        className="save-button mt-4 ms-2 right-margin"
                        onClick={handleSubmit}
                    >
                        Submit
                </button>
            </div>
        </div>
    )
}

EditAssessorModal.propTypes = {
    assessorID: PropTypes.any,
    setAssessorID: PropTypes.any,
    handleCancel: PropTypes.any,
    setVisible: PropTypes.any,
    vendorAssessmentRequestID: PropTypes.any,
    fetchAssessmentListAdmin: PropTypes.any,
    setVendorAssessmentRequestID: PropTypes.any,
    setSearch: PropTypes.any
}

export default EditAssessorModal;